/*
 * @Description:
 * @Author: wanghengzhen
 * @Date: 2022-01-25 09:51:12
 * @LastEditTime: 2022-02-18 10:29:55
 */
import { isString } from "@/utils";
import { equals } from "ramda";
interface ObservedAttributes {
  classname: string;
  value: string;
  disabled: string;
  readonly: string;
}
export class Input extends HTMLInputElement {
  constructor() {
    super();
    this.addEventListener("blur", this.#hdBlur);
  }
  static get observedAttributes() {
    return ["classname", "value", "disabled", "readonly"];
  }
  #hdBlur() {
    if (this.value && isString(this.value)) {
      const value = this.value.trim();
      if (!equals(value, this.value)) {
        this.value = value;
        this.dispatchEvent(
          new Event("input", {
            bubbles: true,
            cancelable: true,
          }),
        );
      }
    }
  }
  #updateClass() {
    const classname = this.getAttribute("classname");
    if (classname) {
      this.className = classname;
    }
  }
  #updateDisabled() {
    const disabled = this.getAttribute("disabled");
    if (disabled) {
      this.disabled = equals(disabled, "true");
    }
  }
  #updateReadonly() {
    const readOnly = this.getAttribute("readOnly");
    if (readOnly) {
      this.readOnly = equals(readOnly, "true");
    }
  }
  attributeChangedCallback(type: keyof ObservedAttributes) {
    switch (type) {
      case "classname":
        this.#updateClass();
        break;
      case "value":
        this.#hdBlur();
        break;
      case "disabled":
        this.#updateDisabled();
        break;
      case "readonly":
        this.#updateReadonly();
        break;
    }
  }
  disconnectedCallback() {
    this.removeEventListener("blur", this.#hdBlur);
  }
}

export function define(name = "r-input") {
  if (customElements.get(name)) return;
  customElements.define(name, Input, { extends: "input" });
}
